import { useEffect, useState } from 'react'
import { Admin, DEFAULT_LOCALE, polyglotI18nProvider, resolveBrowserLocale, Resource } from 'react-admin'
import './App.css'
import './Containers.css'
import accessReducer from './ducks/access'
import actionListenerReducer from './ducks/action_listener'
import activitiesReducer from './ducks/activities'
import appStateReducer from './ducks/app'
import authReducer from './ducks/auth'
import autoDesignReducer from './ducks/autoDesign'
import { featuresReducer } from './ducks/features'
import generateDocumentReducer from './ducks/generateDocument'
import inlineFormReducer from './ducks/inlineForm'
import lastListReducer from './ducks/lastList'
import myEnergyReducer, { myEnergySagas } from './ducks/myEnergy'
import orderComponentsReducer, { orderLineItemSagas } from './ducks/orderComponents'
import projectIdReducer from './ducks/projectId'
import projectMilestonesReducer from './ducks/projectMilestones'
import setQuickStartReducer from './ducks/quickStart'
import recentProjectsReducer from './ducks/recentProjects'
import selectComponentReducer from './ducks/selectComponent'
import selectTariffReducer from './ducks/selectTariff'
import sponsoredTariffsReducer from './ducks/sponsoredTariffs'
import starsReducer from './ducks/stars'
import studioReducer from './ducks/studio'
import studioModeReducer from './ducks/studioMode'
import themeReducer from './ducks/theme'
import transactionReducer from './ducks/transaction'
import uploadLogoReducer from './ducks/uploadLogo'
import utilityApiReducer from './ducks/utilityApi'
import setViewAsCustomer from './ducks/viewAsCustomer'
import welcomeReducer from './ducks/welcome'
import zoneReducer from './ducks/zone'
import designerReducer from './reducer/designer'
import projectReducer from './reducer/project'
import tourReducer from './reducer/tour'
// import walletTransactionsReducer from './ducks/walletTransactions'
import adaNotificationReducer from 'ducks/adaNotification'
import chatDrawerReducer from 'ducks/chatDrawer'
import drawersReducer from 'ducks/drawers'
import inventoryFilterReducer from 'ducks/inventoryFilter'
import learningReducer from 'ducks/learning'
import liteInterfaceReducer from 'ducks/liteInterface'
import projectViewSettingsReducer from 'ducks/projectViewSettings'
import promoSuppressionReducer from 'ducks/promoSuppression'
import lodash from 'lodash'
import inventoryLocations from 'resources/inventoryLocations/lazy'
import './ducks/amplitudeSideEffects'
import electricalReducer from './ducks/electrical'
import featureConfigReducer, { featureConfigSagas } from './ducks/featureConfig'
import formDialogReducer from './ducks/formDialog'
import ironRidgeReducer from './ducks/ironRidge'
import listBulkEditReducer from './ducks/listBulkEdit'
import loadZoneDataReducer, { loadZoneDataSagas } from './ducks/loadZoneData'
import paymentOptionSelectionReducer from './ducks/paymentOptionSelection'
import paymentsPageReducer from './ducks/paymentsPage'
import premiumProductsReducer, { premiumProductsSagas } from './ducks/premiumProducts'
import pvsellReducer from './ducks/pvsell'
import renusolReducer from './ducks/renusol'
import viewModeReducer from './ducks/viewMode'
import walletReducer, { walletSagas } from './ducks/wallet'
import proposalViewers from './resources/proposalViewers/lazy'

import authClient from './authClient'
import defaultTranslations, { templateTranslations } from './i18n'

// Side effect: registers `window.ostools.tours.forceHide` on load (before PersistentContent / lazy chunks).
import PersistentContent from './persistentContent/PersistentContent'
import './persistentContent/tours/tourOstools'
import myApiRestClient from './restClient'
import { NearmapTheme, OpenSolarTheme } from './Themes'

import {
  activeBatteryComponents,
  activeInverterComponents,
  activeModuleComponents,
  activeOtherComponents,
} from './resources/activeComponents'
import Adders from './resources/adders/lazy'
import BatterySchemes from './resources/batterySchemes/lazy'
import commissions from './resources/commissions/lazy'
import { batteryComponents, inverterComponents, moduleComponents, otherComponents } from './resources/components'
import connectedOrgs from './resources/connectedOrgs'
import contacts from './resources/contacts/lazy'
import contracts from './resources/contracts/lazy'
import costings from './resources/costings/lazy'
import countries from './resources/countries/lazy'
import { csvFileUploadLogs, csvFileUploadRequests } from './resources/csvFileUpload/lazy'
import customFields from './resources/customFields/lazy'
import { CustomRoles_orgs, CustomRoles_user } from './resources/customRoles/lazy'
import distributors from './resources/distributors/lazy'
import documentTemplates from './resources/documentTemplates/lazy'
import events from './resources/events/lazy'
import exhibitContents from './resources/exhibitContents/lazy'
import expoStands from './resources/expoStands'
import { globalPublicFiles, privateFiles, publicFiles } from './resources/files/lazy'
import globalContacts from './resources/globalContacts/lazy'
import globalOrgs from './resources/globalOrgs/lazy'
import globalProjects from './resources/globalProjects/lazy'
import globalRoles from './resources/globalRoles/lazy'
import globalSupplierPaymentMethods from './resources/globalSupplierPaymentMethods/lazy'
import globalUsers from './resources/globalUsers/lazy'
import hardwareDistributors from './resources/hardwareDistributors/lazy'
import incentives from './resources/incentives'
import leadCaptureForm from './resources/leadCaptureForm/lazy'
import leadRecipient from './resources/leadRecipients/lazy'
import manufacturers from './resources/manufacturers/lazy'
import myrole from './resources/myrole/lazy'
import networkTariffGroups from './resources/networkTariffGroups/lazy'
import networkTariffs from './resources/networkTariffs/lazy'
import orgContent from './resources/orgContent'
import orgs from './resources/orgs'
import partnerDataMatchingRecords from './resources/partnerRecordMapping/lazy'
import paymentMethods from './resources/paymentMethods/lazy'
import paymentOptions from './resources/paymentOptions'
import PricingSchemes from './resources/pricingSchemes/lazy'
import projectConfigurations from './resources/projectConfigurations'
import projects from './resources/projects'
import proposalTemplates from './resources/proposalTemplates'
import roles from './resources/roles'
import roofTypes from './resources/roofTypes/lazy'
import salesTerritories from './resources/salesTerritories/lazy'
import structs from './resources/structs'
import tags from './resources/tags/lazy'
import testimonials from './resources/testimonials/lazy'
import transactions from './resources/transactions/lazy'
import utilities from './resources/utilities/lazy'
import utilityTariffGroups from './resources/utilityTariffGroups/lazy'
import utilityTariffs, { customTariffCurrent, customTariffProposed } from './resources/utilityTariffs'
import { SHOPIFY_STOREFRONT_API_VERSION } from './storeFrontQuery'

import apiRequestLog from './resources/apiRequestLog/lazy'
import landingPages from './resources/landingPages/lazy'
import orderingOrders from './resources/orderingOrders/lazy'
import orderingQuotes from './resources/orderingQuotes/lazy'
import userSessions from './resources/userSessions/lazy'
import wallet from './resources/wallet'
import walletProducts from './resources/walletProducts/lazy'
import walletProductVariants from './resources/walletProductVariants/lazy'
import walletTransactions from './resources/walletTransactions'
import webhookProcessLog from './resources/webhookProcessLog/lazy'
import webhooks from './resources/webhooks/lazy'

import PageRegister from 'pages/auth/lazy'
import CustomLayout from './layout/CustomLayout'

import customRoutes from './routes'

import authSaga from './sagas/authSaga'
import designerSideEffects from './sagas/designerSaga'
import projectSaga from './sagas/projectSaga'
import restSaga from './sagas/restSaga'

import { createBrowserHistory } from 'history'
//storefrontcheckout
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client'

//sentry.io
import * as Sentry from '@sentry/react'

import { rolesSagas } from 'ducks/auth_roles'
import consumptionCurvesReducer, { consumptionCurvesSagas } from 'ducks/consumptionCurves'
import exhibitorsReducer, { exhibitorsSagas } from 'ducks/exhibitors'
import googleLeadsReducer, { googleLeadsConfigSagas } from 'ducks/googleLeadsConfig'
import orgsReducer, { orgsSagas } from 'ducks/orgs'
import { permissionsReducer } from 'ducks/permissions'
import projectListViewsReducer, { projectListViewsSagas } from 'ducks/projectListViews'
import { tariffSagas } from 'ducks/tariff'
import { walletTransactionSagas } from 'ducks/walletTransactions'
import wsReducer, { wsSagas } from 'ducks/websocket'

import { LOCALES_SUPPORTED } from 'constants/locales'
import walletProductIntegrationsReducer, { walletProductIntegrationsSagas } from 'ducks/walletProductIntegrations'
import { CustomWithPermissions } from 'elements/react-admin/CustomWithPermissions'
import { initSentry } from 'errors/sentry/initSentry'
import { useErrorHandlingOverrides } from 'errors/useErrorHandlingOverrides'
import useUiKey from 'hooks/useUiKey'
import { CustomAdminUI } from 'layout/CustomAdminUI'
import { amplitudeLogger } from 'loggers/amplitudeLogger'
import { ga4Logger, TrackingProvider } from 'opensolar-common'
import { OsUiRootContext } from 'opensolar-ui'
import globalCartReducer from 'reducer/globalCart'
import actions from 'resources/actions/lazy'
import adCampaigns from 'resources/adCampaigns/lazy'
import adCreatives from 'resources/adCreatives/lazy'
import adFormats from 'resources/adFormats/lazy'
import adPlacements from 'resources/adPlacements/lazy'
import adSites from 'resources/adSites/lazy'
import brands from 'resources/brands/lazy'
import { cashflowPricingScheduleActivations, cashflowPricingSchedules } from 'resources/cashflowPricing'
import cashflowSetupCheckpoints from 'resources/cashflowSetupCheckpoints'
import customers from 'resources/customers/lazy'
import customForms from 'resources/customForms/lazy'
import deals from 'resources/deals/lazy'
import expoHomepages from 'resources/expoHomepages/lazy'
import financeCTAs from 'resources/financeCTAs'
import financeIntegrations from 'resources/financeIntegrations'
import financeProducts from 'resources/financeProducts'
import financeProductTerms from 'resources/financeProductTerms/lazy'
import financeValidationSets from 'resources/financeValidationSets/lazy'
import paymentFactors from 'resources/paymentFactors/lazy'
import quotes from 'resources/quotes/lazy'
import supplierQuotes from 'resources/supplierQuotes/lazy'
import systemTemplates from 'resources/systemTemplates/lazy'
import workflows from 'resources/workflows/lazy'
import appStorage, { getLocale, setLocale } from 'storage/appStorage'
import 'storage/customLocalStorage' // Sets up window.getStorage()
import { amplitudeSideEffects } from './ducks/amplitudeSideEffects'
import overdueActionsReducer, { overdueActionsSaga } from './ducks/overdueActions'
import VoiceProvider from './voice/OpenAIRealtimeVoiceAPI/VoiceProvider'

const showTranslationIcons = 'showTranslationIcons'
const isLocal = !window.ENV || window.ENV === 'local'
if (isLocal && !appStorage.has(showTranslationIcons)) appStorage.setBool(showTranslationIcons, true)

const outletStorefrontClient = new ApolloClient({
  uri: `${window.OUTLET_STOREFRONT_DOMAIN}/api/${SHOPIFY_STOREFRONT_API_VERSION}/graphql.json`,
  headers: {
    'X-Shopify-Storefront-Access-Token': window.OUTLET_STOREFRONT_ACCESS_TOKEN,
  },
  cache: new InMemoryCache(),
})

const stripTrailingSlash = (str) => {
  if (str.endsWith('/')) return str.slice(0, -1)
  else return str
}

// The absolute URL to the root of the API server
// In most scnearios this doesn't include `/api`.
// In Review Instances, this will have `/api` at the end, which will get another `/api` appended to it in `API_BASE_URL`.
// This is expected
window.API_ROOT_ABSOLUTE = stripTrailingSlash(
  window.API_ROOT.startsWith('http:') || window.API_ROOT.startsWith('https:')
    ? window.API_ROOT
    : window.location.origin + window.API_ROOT
)

const API_URL = window.API_ROOT + '/api'

//TODO: Remove trailing slash from API_BASE_URL
window.API_BASE_URL = API_URL + '/'

// Should preferentially use API_BASE_URL
// Only when creating a URL which needs to be used outside of OS should we rely on API_BASE_URL_ABSOLUTE
window.API_BASE_URL_ABSOLUTE = window.API_ROOT_ABSOLUTE + '/api/'

// const history = createHashHistory()
export const history = createBrowserHistory()

history.listen(function (location) {
  window.GA4?.recordPageView()

  if (window && window.RUNNING_AS_APP) {
    var pagePathLocal = location.pathname + location.search
    window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'navigationChangeHack', pagePath: pagePathLocal }))
  }
})

window.reactReduxHistory = history

var localeImporters = {
  en: () => import('./i18n/en.js'),
  en_US: () => import('./i18n/en_US.js'),
  es: () => import('./i18n/es.js'),
  es_MX: () => import('./i18n/es_MX.js'),
  fi: () => import('./i18n/fi.js'),
  fr: () => import('./i18n/fr.js'),
  da: () => import('./i18n/da.js'),
  de: () => import('./i18n/de.js'),
  it: () => import('./i18n/it.js'),
  nl: () => import('./i18n/nl.js'),
  no: () => import('./i18n/no.js'),
  pl: () => import('./i18n/pl.js'),
  pt: () => import('./i18n/pt.js'),
  sv: () => import('./i18n/sv.js'),
  th: () => import('./i18n/th.js'),
  zh: () => import('./i18n/zh.js'),
}

export const loadMessagesForLocale = async (locale) => {
  var importFunction = localeImporters[locale] || localeImporters[DEFAULT_LOCALE]

  return new Promise((resolve, reject) => {
    importFunction()
      .then((messages) => {
        resolve({
          ...messages,
          default: lodash.merge({}, templateTranslations, messages.default),
        })
      })
      .catch(reject)
  })
}

export const getPolyglotI18nProvider = (initialLocale, initialTranslation) => {
  const ret = polyglotI18nProvider(
    (locale) => {
      if (locale === initialLocale) {
        // initial call, must return synchronously
        return initialTranslation
      }

      return loadMessagesForLocale(locale)
        .then((messages) => messages.default)
        .catch((error) => {
          console.warn('getLocale error', error)
          return defaultTranslations[DEFAULT_LOCALE]
        })
    },
    initialLocale,
    {
      allowMissing: true,
      onMissingKey: (key, options) => {
        // Still resolve variables when term isn't found
        if (typeof key === 'string')
          for (const i in options) {
            key = key.replace(new RegExp(`%{${i}}`), options[i])
          }
        return key
      },
    }
  )

  const trans = ret.translate
  ret.translate = (key, options = {}) => {
    if (!key) return ''
    else if (appStorage.getBool(showTranslationIcons)) {
      const ret = trans(key, options)
      const icon = lodash.get(templateTranslations, key) ? '✅' : '❌'
      if (!ret) return icon
      else if (typeof ret === 'string') return icon + ' ' + ret
      else return [icon, ret]
    } else return trans(key, options)
  }

  return ret
}

initSentry(isLocal)

const App = () => {
  const [initialLocale, setInitialLocale] = useState(null)
  const [initialTranslation, setInitialTranslation] = useState(null)
  const [invalidUsageReason, setInvalidUsageReason] = useState(undefined)
  const themes = { opensolar: OpenSolarTheme, nearmap: NearmapTheme }
  const customSagas = [
    ...designerSideEffects,
    tariffSagas,
    projectSaga,
    myEnergySagas,
    orderLineItemSagas,
    walletTransactionSagas,
    walletSagas,
    featureConfigSagas,
    premiumProductsSagas,
    orgsSagas,
    exhibitorsSagas,
    walletProductIntegrationsSagas,
    googleLeadsConfigSagas,
    consumptionCurvesSagas,
    projectListViewsSagas,
    wsSagas,
    rolesSagas,
    authSaga(authClient),
    restSaga(myApiRestClient(API_URL)),
    loadZoneDataSagas,
    amplitudeSideEffects,
    overdueActionsSaga,
  ]
  const errorHandlingOverrides = useErrorHandlingOverrides()

  useEffect(() => {
    const initialization = async () => {
      let locale = getLocale() || resolveBrowserLocale()
      //format locale e.g. en-US => en_US
      locale = locale.replace('-', '_')
      if (Object.keys(LOCALES_SUPPORTED).indexOf(locale) === -1) {
        //use standard language if specific locale not found
        locale = locale.split('_')[0]
        if (Object.keys(LOCALES_SUPPORTED).indexOf(locale) === -1) {
          //use default locale if language not found
          locale = DEFAULT_LOCALE
        }
      }
      setLocale(locale)
      const message = await loadMessagesForLocale(locale)
        .then((messages) => messages.default)
        .catch((error) => {
          console.warn('getLocale error', error)
          locale = DEFAULT_LOCALE
          return defaultTranslations[DEFAULT_LOCALE]
        })
      setInitialLocale(locale)
      setInitialTranslation(message)
    }

    initialization()
  }, [])

  useEffect(() => {
    if (invalidUsageReason) Sentry.captureException(invalidUsageReason)
  }, [invalidUsageReason])

  if (!initialLocale || !initialTranslation) {
    // we couldn't detect theme color at this stage as redux is not ready yet
    const loaderColor = '#e2dede'
    return (
      <div className="loader-container">
        <div className="loader" style={{ color: loaderColor }} />
      </div>
    )
  }

  //TODO move this to redux
  window.setInvalidUsageReason = setInvalidUsageReason
  // Introduced for IAPs in mobile
  // However window.RUNNING_AS_APP_DEVICE is not always correctly injected by webview here and causing this app crash https://opensolar.atlassian.net/browse/GS-1923
  // We have a better solution variable injection here https://github.com/open-solar/sunsuite/pull/16376
  // Let's remove the following code once release new app with above change. (Note: test IAPs again after removing)
  window.RUNNING_AS_APP = !!window.RUNNING_AS_APP_DEVICE

  if (invalidUsageReason) {
    return (
      <>
        <div>Invalid usage, please check client key or contact OpenSolar support.</div>
        <div>{invalidUsageReason}</div>
      </>
    )
  }

  return (
    <ApolloProvider client={outletStorefrontClient}>
      <OsUiRootContext>
        <TrackingProvider loggers={{ amplitude: amplitudeLogger, ga4: ga4Logger }} resolveUiKey={useUiKey}>
          <VoiceProvider history={history}>
            <Admin
              title="OpenSolar"
              dataProvider={myApiRestClient(API_URL)}
              customReducers={{
                studio: studioReducer,
                features: featuresReducer,
                studioMode: studioModeReducer,
                designer: designerReducer,
                project: projectReducer,
                inlineForm: inlineFormReducer,
                viewAsCustomer: setViewAsCustomer,
                theme: themeReducer,
                zone: zoneReducer,
                projectId: projectIdReducer,
                actionListener: actionListenerReducer,
                autoDesign: autoDesignReducer,
                recentProjects: recentProjectsReducer,
                stars: starsReducer,
                tour: tourReducer,
                auth: authReducer,
                permissions: permissionsReducer,
                lastList: lastListReducer,
                app: appStateReducer,
                generateDocument: generateDocumentReducer,
                selectTariff: selectTariffReducer,
                selectComponent: selectComponentReducer,
                utilityApi: utilityApiReducer,
                transaction: transactionReducer,
                quickStart: setQuickStartReducer,
                // menu: setMenuReducer,
                welcome: welcomeReducer,
                uploadLogo: uploadLogoReducer,
                access: accessReducer,
                myEnergy: myEnergyReducer,
                orderComponents: orderComponentsReducer,
                activities: activitiesReducer,
                overdueActions: overdueActionsReducer,
                pvsell: pvsellReducer,
                ironRidge: ironRidgeReducer,
                renusol: renusolReducer,
                featureConfig: featureConfigReducer,
                wallet: walletReducer,
                viewMode: viewModeReducer,
                // walletTransactions: walletTransactionsReducer,
                premiumProducts: premiumProductsReducer,
                learning: learningReducer,
                orgs: orgsReducer,
                exhibitors: exhibitorsReducer,
                googleLeadsConfig: googleLeadsReducer,
                consumption_curves: consumptionCurvesReducer,
                websocket: wsReducer,
                liteInterface: liteInterfaceReducer,
                drawers: drawersReducer,
                chatDrawer: chatDrawerReducer,
                inventoryFilter: inventoryFilterReducer,
                projectViewSettings: projectViewSettingsReducer,
                electrical: electricalReducer,
                formDialog: formDialogReducer,
                listBulkEdit: listBulkEditReducer,
                paymentOptionSelection: paymentOptionSelectionReducer,
                paymentsPage: paymentsPageReducer,
                projectMilestones: projectMilestonesReducer,
                loadZoneData: loadZoneDataReducer,
                projectListViews: projectListViewsReducer,
                promoSuppression: promoSuppressionReducer,
                globalCart: globalCartReducer,
                adaNotification: adaNotificationReducer,
                sponsoredTariffs: sponsoredTariffsReducer,
                walletProductIntegrations: walletProductIntegrationsReducer,
              }}
              themePackages={themes}
              authProvider={authClient}
              customRoutes={customRoutes}
              customSagas={customSagas}
              customWithPermissions={CustomWithPermissions}
              loginPage={PageRegister}
              i18nProvider={getPolyglotI18nProvider(initialLocale, initialTranslation)}
              ui={CustomAdminUI}
              layout={CustomLayout}
              history={history}
              persistentContent={<PersistentContent API_URL={API_URL} />}
              errorHandlingOverrides={errorHandlingOverrides}
            >
              {(permissions) => {
                return [
                  <Resource name="projects" {...projects} />,
                  <Resource name="projects___aliases" />,
                  <Resource name="orgs" {...orgs} />,
                  <Resource name="roles" {...roles} />,
                  <Resource name="roles___aliases" />,
                  <Resource name="permissions_role___aliases" />,
                  <Resource name="myroles" {...myrole} />,
                  <Resource name="lead_capture_forms" {...leadCaptureForm} />,
                  <Resource name="lead_recipients" {...leadRecipient} />,
                  <Resource name="tags" {...tags} />,
                  <Resource name="workflows" {...workflows} />,
                  <Resource name="actions" {...actions} />,
                  <Resource name="stages" {...{}} />,
                  <Resource name="countries" {...countries} />,
                  <Resource name="commissions" {...commissions} />,
                  <Resource name="public_orgs" />,
                  <Resource name="my_projects" />,
                  <Resource name="file_tags" />,
                  <Resource name="inventory_transfers" />,
                  <Resource name="inventory_transfer/incoming" />,
                  <Resource name="inventory_transfer/outgoing" />,
                  <Resource name="systems" />,
                  <Resource name="components" />,
                  <Resource name="componentsv2" />,
                  <Resource name="components___aliases" />,
                  <Resource name="transition_to_utility_tariffs" />,
                  <Resource name="custom_tariff_proposed" {...customTariffProposed} />,
                  <Resource name="custom_tariff_current" {...customTariffCurrent} />,
                  <Resource name="events" {...events} />,
                  <Resource name="content" {...orgContent} />,
                  <Resource name="contacts" {...contacts} />,
                  <Resource name="manufacturers" {...manufacturers} />,
                  <Resource name="roof_types" {...roofTypes} />,
                  <Resource name="adders" {...Adders} />,
                  <Resource name="battery_schemes" {...BatterySchemes} />,
                  <Resource name="pricing_schemes" {...PricingSchemes} />,
                  <Resource name="system_templates" {...systemTemplates} />,
                  <Resource name="custom_fields" {...customFields} />,
                  <Resource name="custom_forms" {...customForms} />,
                  <Resource name="permissions_role" {...CustomRoles_user} />,
                  <Resource name="connected_orgs_roles" {...CustomRoles_orgs} />,
                  <Resource name="costings" {...costings} />,
                  <Resource name="sales_territories" {...salesTerritories} />,
                  <Resource name="transactions" {...transactions} />,
                  <Resource name="testimonials" {...testimonials} />,
                  <Resource name="inventory_locations" {...inventoryLocations} />, // no entry point
                  <Resource name="contracts" {...contracts} />,
                  <Resource name="global_contracts" />,
                  <Resource name="component_content" {...exhibitContents} />,
                  <Resource name="document_templates" {...documentTemplates} />,
                  <Resource name="global_document_templates" />,
                  <Resource name="all_available_document_templates" />,
                  <Resource name="distributors" {...distributors} />,
                  <Resource name="csv_file_upload_requests" {...csvFileUploadRequests} />,
                  <Resource name="csv_file_upload_logs" {...csvFileUploadLogs} />,
                  <Resource name="utilities" {...utilities} />,
                  <Resource name="utility_tariffs" {...utilityTariffs} />,
                  <Resource name="utility_tariffs___aliases" />,
                  <Resource name="utility_tariff_groups" {...utilityTariffGroups} />,
                  <Resource name="network_tariff_groups" {...networkTariffGroups} />,
                  <Resource name="network_tariffs" {...networkTariffs} />,
                  <Resource name="component_modules" {...moduleComponents} />,
                  <Resource name="component_others" {...otherComponents} />,
                  <Resource name="component_inverters" {...inverterComponents} />,
                  <Resource name="component_batteries" {...batteryComponents} />,
                  <Resource name="incentives" {...incentives} />,
                  <Resource name="proposal_templates" {...proposalTemplates} />,
                  <Resource name="project_configurations" {...projectConfigurations} />,
                  <Resource name="component_module_activations" {...activeModuleComponents} />,
                  <Resource name="component_inverter_activations" {...activeInverterComponents} />,
                  <Resource name="component_battery_activations" {...activeBatteryComponents} />,
                  <Resource name="component_other_activations" {...activeOtherComponents} />,
                  <Resource name="payment_methods" {...paymentMethods} />,
                  <Resource name="partner_data_matching_records" {...partnerDataMatchingRecords} />,
                  <Resource name="payment_options" {...paymentOptions} />,
                  <Resource name="public_files" {...publicFiles} />,

                  <Resource name="private_files" {...privateFiles} />,
                  <Resource name="global_public_files" {...globalPublicFiles} />,
                  <Resource name="global_orgs" {...globalOrgs} />,
                  <Resource name="global_projects" {...globalProjects} />,
                  <Resource name="global_contacts" {...globalContacts} />,
                  <Resource name="global_roles" {...globalRoles} />,
                  <Resource name="global_users" {...globalUsers} />,
                  <Resource name="ordering_orders" {...orderingOrders} />,
                  <Resource name="ordering_quotes" {...orderingQuotes} />,
                  <Resource name="wallet_transactions" {...walletTransactions} />,
                  <Resource name="global_wallet_transactions" {...walletTransactions} />,
                  <Resource name="wallets" {...wallet} />,
                  <Resource name="landing_pages" {...landingPages} />,
                  <Resource name="superuser_wallet_products" {...walletProducts} />,
                  <Resource name="superuser_wallet_product_variants" {...walletProductVariants} />,
                  <Resource name="finance_partners" {...financeIntegrations} />,
                  <Resource name="cashflow_pricing_schedules" {...cashflowPricingSchedules} />,
                  <Resource name="cashflow_pricing_schedule_activations" {...cashflowPricingScheduleActivations} />,
                  <Resource name="cashflow_setup_checkpoints" {...cashflowSetupCheckpoints} />,
                  <Resource name="payment_factors" {...paymentFactors} />,
                  <Resource name="finance_validation_sets" {...financeValidationSets} />,
                  <Resource name="finance_products" {...financeProducts} />,
                  <Resource name="finance_product_terms" {...financeProductTerms} />,
                  <Resource name="finance_ctas" {...financeCTAs} />,
                  <Resource name="proposal_viewers" {...proposalViewers} />,
                  <Resource name="connected_orgs" {...connectedOrgs} />,
                  <Resource name="cashflow_projects" />,
                  <Resource name="cashflow_invoices" />,
                  <Resource name="global_hardware_suppliers" {...hardwareDistributors} />,
                  <Resource name="global_supplier_payment_methods" {...globalSupplierPaymentMethods} />,
                  <Resource name="structs" {...structs} />,
                  <Resource name="struct-types" />,
                  <Resource name="expo_stands" {...expoStands} />,
                  <Resource name="expo_homepages" {...expoHomepages} />,
                  <Resource name="brands" {...brands} />,
                  <Resource name="ads/ad_campaigns" {...adCampaigns} />,
                  <Resource name="ads/segments" />,
                  <Resource name="ads/ad_placements" {...adPlacements} />,
                  <Resource name="ads/ad_sites" {...adSites} />,
                  <Resource name="ads/ad_formats" {...adFormats} />,
                  <Resource name="ads/ad_creatives" {...adCreatives} />,
                  <Resource name="google_leads_config" />,
                  <Resource name="public_videos" />,
                  <Resource name="google_lead_project" />,
                  <Resource name="profile_page" />,
                  <Resource name="customers" {...customers} />,
                  <Resource name="price_list" />,
                  <Resource name="stock_locations" />,
                  <Resource name="quotes" {...quotes} />,
                  <Resource name="supplier_quotes" {...supplierQuotes} />,
                  <Resource name="api_request_logs" {...apiRequestLog} />,
                  <Resource name="user_sessions" {...userSessions} />,
                  <Resource name="webhooks" {...webhooks} />,
                  <Resource name="webhook_process_logs" {...webhookProcessLog} />,
                  <Resource name="deals" {...deals} />,
                ]
              }}
            </Admin>
          </VoiceProvider>
        </TrackingProvider>
      </OsUiRootContext>
    </ApolloProvider>
  )
}

export default App
